import { Component, inject, input, LOCALE_ID, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-city',
  imports: [ReactiveFormsModule],
  templateUrl: './city.html',
  styleUrl: './city.scss',
})
export class City {
  private locale = inject(LOCALE_ID);
  pharmacyForm = input.required<FormGroup>();
  cities = input.required<{ id: number; titleAr?: string; titleEn: string; profileImageFid?: string }[]>();
  onGetRegions = output<{ cityId: number }>();
  isArabic() {
    return this.locale.startsWith('ar');
  }
  isEnglish() {
    return this.locale.startsWith('en');
  }

  onChangeCity() {
    const cityId = this.pharmacyForm().get('pharmacyCity')?.value;
    this.onGetRegions.emit({ cityId });
  }
}
